import { IngredientDataType, IngredientType } from "../../../../config/enums/IngredientType.enum";
import { PackageFlags } from "../../../ingredients/ingredientRegister/supplierRegister.types";

interface ValidateData {
  country: number;
  specifyIngredientValue: string;
  produceType: string;
  ingredientType: string;
}

/**
 * Static-method port of the pure `useMemo` derivations in the legacy
 * `IngredientRegisterModalView.tsx` — single-responsibility, independently
 * testable, no React/state. Each method mirrors one of that file's memos
 * 1:1 so the register form's footer/section-visibility logic is byte-for-byte
 * the same, just computed outside a component.
 */
export class IngredientRegisterButtonState {
  static disableCalculateButton(
    isSupplierFormOpen: boolean,
    supplierValidation: boolean,
    currentSupplierId: unknown
  ): boolean {
    return !((isSupplierFormOpen && supplierValidation) || Boolean(currentSupplierId));
  }

  static enablePackageData(
    loadPackageData: boolean,
    packageFlags: PackageFlags,
    viewEnvironmentalData: boolean
  ): boolean {
    return loadPackageData && packageFlags.enableIngredient && viewEnvironmentalData;
  }

  static enableTransportData(
    loadPackageData: boolean,
    packageFlags: PackageFlags,
    viewEnvironmentalData: boolean
  ): boolean {
    const enableTransportDetails =
      loadPackageData && packageFlags.processIngredient && viewEnvironmentalData;
    return (
      enableTransportDetails ||
      (!enableTransportDetails && packageFlags.enableIngredient && viewEnvironmentalData)
    );
  }

  static enableLCAData(packageFlags: PackageFlags, viewEnvironmentalData: boolean): boolean {
    return packageFlags.lcaIngredient && viewEnvironmentalData;
  }

  static enableIngredientMapping(
    currentDataType: string,
    ingredientId: unknown,
    supplierId: unknown,
    viewEnvironmentalData: boolean
  ): boolean {
    return (
      (currentDataType === IngredientDataType.USER ||
        currentDataType === IngredientDataType.GENERIC) &&
      Boolean(ingredientId) &&
      Boolean(supplierId) &&
      viewEnvironmentalData
    );
  }

  static isGenericCalculationReady(
    currentDataType: string,
    viewEnvironmentalData: boolean,
    validateData: ValidateData
  ): boolean {
    if (currentDataType !== IngredientDataType.GENERIC || !viewEnvironmentalData) return false;

    if (validateData.ingredientType === IngredientType.RAW) {
      return Boolean(validateData.country && validateData.produceType?.trim());
    }

    if (validateData.ingredientType === IngredientType.PROCESSED) {
      return Boolean(validateData.country && validateData.specifyIngredientValue?.trim());
    }

    return false;
  }

  static genericButtonTitle(isGenericCalculationReady: boolean): string {
    return isGenericCalculationReady ? "Save and Calculate" : "Save";
  }

  static enableIngredientButton(supplierDataType?: string): boolean {
    return supplierDataType
      ? !(
          supplierDataType === IngredientDataType.USER ||
          supplierDataType === IngredientDataType.GENERIC
        )
      : true;
  }
}
